import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "New Phone",
  "description": "",
  "published": "2007-04-09T00:00:00.000Z",
  "redirect_from": ["/blog/new-phone/swizec/239"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`On Friday I acquired a new cell phone because the old one was beginning to be quite too untrustworthy. The blood thing would shut down when I wanted to answer a call and other such idiocy.`}</p>
    <p>{`The phone I got is the lovely `}<a parentName="p" {...{
        "href": "http://www.sonyericsson.com/spg.jsp?cc=global&lc=en&ver=4001&template=pp1_1_1&zone=pp&lm=pp1&pid=10457"
      }}>{`Sony Ericsson V630i`}</a>{` and I have to say I'm very pleased with it thusfar. It does everything I need it to do and a lot of what I don't need it to do at all. The good thing is it can double for a portable music player and thus help in decluttering my pockets. It's silly though that I had to spend an additional 70€ just to buy a pair of decent compatible headphones and a one gigabyte large memory stick.`}</p>
    <p>{`Another thing that really bothers me is file transfer. When you plug the phone in the USB it begins to charge, all fine and well, when the transfering is over the battery is eaten quite a lot. WTF? And why does the transfer itself have to be this bloody slow? Is somebody hating linux perhaps?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      